import './prod-url-patch';

import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index.js'

import GoogleLogin from 'vue3-google-login'

// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css'

// Import Bootstrap Icons
import 'bootstrap-icons/font/bootstrap-icons.css'

// Import Bootstrap JavaScript
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// Ensure Bootstrap is globally available 
window.addEventListener('DOMContentLoaded', () => {
  if (typeof window.bootstrap === 'undefined') {
    console.warn('Bootstrap JS not loaded properly')
  }
})

// Import custom styles (should come after Bootstrap)
import './assets/styles.css'

const app = createApp(App)

const googleClientId = process.env.VUE_APP_GOOGLE_CLIENT_ID
if (googleClientId) {
  app.use(GoogleLogin, { clientId: googleClientId })
} else {
  // Optional: helps you see if the env var is missing on Netlify
  console.warn('VUE_APP_GOOGLE_CLIENT_ID is not set. Google Sign-In will not initialize.')
}

app.use(router)
app.mount('#app')
